import React from "react";
import ProformaInvoices from "pages/ProformaInvoices";

// همه سفارش‌ها = همان فهرست GET /proforma-invoices/ بدون فیلتر order_status، یعنی هر
// پیش‌فاکتور ثبت‌شده در هر وضعیتی (پیش‌فاکتور، سفارش فروش، در حال تولید، ... ، تحویل‌شده).
// از همان کامپوننت صفحه پیش‌فاکتورها استفاده می‌کند تا ستون‌ها، مودال‌ها و مجوزها یکی بمانند؛
// فقط عنوان‌ها فرق می‌کنند و دکمه «ایجاد پیش‌فاکتور» اینجا نمایش داده نمی‌شود چون این صفحه
// نمای کلی است و ایجاد در خودِ صفحه پیش‌فاکتورها انجام می‌شود.
const Index = () => (
  <ProformaInvoices
    pageTitle="همه سفارش‌ها"
    totalLabel="مجموع سفارش‌ها"
    emptyText="هیچ سفارشی ثبت نشده است"
    showCreateButton={false}
    // بدون فیلتر وضعیت: هر پیش‌فاکتور در هر وضعیتی اینجا دیده می‌شود.
    // «تأیید پرداختی» طبق مستند متعلق به همین بخش است.
    section="allOrders"
    orderStatus={null}
    // نوار فیلترها و ستون مستقل «تاریخ» (بلافاصله بعد از «کارشناس فروش») طبق مستند.
    showFilters
    showDateColumn
    // این صفحه پرستون‌ترین جدول را دارد؛ در موبایل فقط ۲ ستون نشان داده می‌شود
    // و بقیه با دکمه‌ی + هر ردیف باز می‌شوند.
    mobileColumns={2}
  />
);

export default Index;
